const countryCenters = {
    "nb": { lat: 60.4720, lng: 8.4689 },  // Norwegian (Norway)
    "fi": { lat: 64.0000, lng: 26.0000 }, // Finnish (Finland)
    "da": { lat: 56.2639, lng: 9.5018 },  // Danish (Denmark)
    "nl": { lat: 52.3676, lng: 4.9041 },  // Dutch (Netherlands)
    "fr": { lat: 46.6034, lng: 1.8883 },  // French (France)
    "en": { lat: 52.4333, lng: -1.6167 }, // English (England)
    "sv": { lat: 60.5, lng: 15.5 },       // Swedish (default: Sweden)
};

const getDefaultCenterByLanguage = () => {
    const langAttr = document.body.dataset.ctxculture || "sv";
    const baseLang = langAttr.includes('-') ? langAttr.split('-')[0] : langAttr;

    return countryCenters[baseLang] || countryCenters["sv"];
};
